import React from 'react';
import { MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  selectOrgGroups,
  selectRetrieveGroupsState,
} from '../modules/orgGroups.js';
import Empty from './Empty.jsx';
import { CloseIcon } from './icons/CloseIcon.jsx';
import GroupSearchSelect from './GroupSearchSelect.jsx';
import styles from './GroupsBulkSelect.module.css';

const mapStateToProps = (state) => ({
  groups: selectOrgGroups(state),
  retrieveSuccess: selectRetrieveGroupsState(state),
});

function GroupsBulkSelect(props) {
  const {
    groups,
    selected,
    handleSelect,
    customClass,
    isItemActive,
    isGroupSelectDisabled,
    disabledGroupIds = [],
    showArchived,
  } = props;

  const isActive = (id) => (isItemActive ? isItemActive(id) : id in selected);
  const renderMenuItem = (group) => {
    if (!showArchived && group.archived) return null;
    return (
      <React.Fragment key={group.id}>
        <MenuItem
          active={isActive(group.id)}
          eventKey={group}
          onSelect={() => handleSelect(group)}
          disabled={disabledGroupIds.includes(group.id)}
        >
          <span
            className={
              group.archived && !isActive(group.id) ? 'text-muted' : ''
            }
          >
            {group.archived
              ? `${group.name || ''} (archived)`
              : group.name || ''}
          </span>
        </MenuItem>
        {group.children?.length > 0 && (
          <li>
            <ul className={styles.groupsFilterSubmenu}>
              {group.children.map(renderMenuItem)}
            </ul>
          </li>
        )}
      </React.Fragment>
    );
  };

  const renderGroupItem = (group) => {
    const name = group.name || '';
    const archived = group?.archived ? '(archived)' : '';
    return (
      <div key={group.id} className="flex m-t-4 m-l-4 item-style">
        {name}
        &nbsp;
        {archived}
        <span
          className="btn btn-clear close-btn"
          onClick={() => (!isGroupSelectDisabled ? handleSelect(group) : null)}
        >
          <CloseIcon />
        </span>
      </div>
    );
  };

  return groups ? (
    <div className={`${styles.groupsBulkSelect} m-b-24 ${customClass || ''}`}>
      <div className="bulk-select m-b-12">
        <div
          className="flex flex-align-start flex-wrap"
          style={{ background: isGroupSelectDisabled ? '#f7fafd' : 'auto' }}
        >
          {Object.values(selected).map((group) => renderGroupItem(group))}
        </div>
        <GroupSearchSelect
          groups={groups}
          selectedGroups={selected}
          onSelectGroup={handleSelect}
          disabled={isGroupSelectDisabled}
          showArchived={showArchived}
          disabledGroupIds={disabledGroupIds}
          title="Select Group(s)"
          style={{ padding: '8px 15px', width: '100%' }}
          className="dropdown-toggle btn btn-info btn-clear btn-no-left-border"
        />
      </div>
    </div>
  ) : (
    <Empty simplified />
  );
}

export default connect(mapStateToProps, null)(GroupsBulkSelect);
